<script>
export default {  
  computed: {
    isFormIncomplete() {
      return Object.values(this.fields).some((a) => !a);
    }
  },

  data() {
    return {
      fields: { email: '', fname: '', lname: '' },
      message: null,
      messageType: 'success',
      waiting: false,
    };
  },
  
  methods: {
    async getToken() {
      grecaptcha.ready(() => {
        grecaptcha
          .execute('6LdqsAMqAAAAAKQUTtDJN9Xhqp5PUufWHAAklKBu', {
            action: 'newsletter',
          })
          .catch((error) => {
            console.error('Error executing reCAPTCHA:', error);
          })
          .then((res) => {
            this.submitForm(res);
          });
      });
    },

    async submitForm(token) {
      this.waiting = true;

      /**
       * Send request to server API.
       */
      const response = await fetch('/wp-json/bpp/v1/newsletter', {
        body: JSON.stringify({
          formData: this.fields,
          token,
        }),
        method: 'POST',
      });

      /**
       * Display success or error message.
       */
      if (response) {
        this.waiting = false;

        const { message } = await response.json();

        this.message = message;

        if (response.ok) {
          this.messageType = 'success';
          this.fields = { email: '', fname: '', lname: '' };
        } else {
          this.messageType = 'error';
        }
      }
    },
  },

  name: 'newsletter',
};
</script>